






































import { Component, Vue, Watch } from 'vue-property-decorator'
import { ITUNES_GENRES } from '@/helpers/itunes'
import { MUSICCHARTS_TRACKS_COUNTRY_CODE_STORAGE_KEY } from '@/constants'

enum VIEWS {
  GenreSelect = 'genre_select',
  TrackList = 'track_list'
}

@Component({
  components: {
    GenreSelect: require('./GenreSelect').default,
    MusicChartsTrackList: require('./MusicChartsTrackList').default,
    ProgressLoader: require('@/components/ProgressLoader').default
  }
})
export default class MusicCharts extends Vue {
  // countryCode: string | null = null
  // genreId: number | null = null

  // countries: { a: string; l: string }[] = require('@/assets/countries.json')
  // itunesCountryCodes: string[] = require('@/assets/itunesCountryCodes.json')
  // genres = ITUNES_GENRES

  // view: VIEWS = VIEWS.GenreSelect
  // loading: boolean = false
  // initialized: boolean = false

  // get itunesCountries() {
  //   return this.countries.filter(c => this.itunesCountryCodes.includes(c.a))
  // }

  // get routeName() {
  //   return this.$route.name
  // }

  // get genreName(): string {
  //   const genre = this.genres.find(x => x.id === this.genreId)

  //   if (genre) return genre.label

  //   return ''
  // }

  // async created() {
  //   this.countryCode = localStorage.getItem(MUSICCHARTS_TRACKS_COUNTRY_CODE_STORAGE_KEY)

  //   if (!this.countryCode || !this.itunesCountries.find(x => x.a === this.countryCode)) this.countryCode = 'US' // Default to US

  //   this.genreId = parseInt(this.$route.params.genreId, 10)

  //   await this.$store.dispatch('musiccharts/fetchOwnedItunesTrackIds')
  // }

  // @Watch('countryCode')
  // saveCountryCode() {
  //   if (this.countryCode) {
  //     localStorage.setItem(MUSICCHARTS_TRACKS_COUNTRY_CODE_STORAGE_KEY, this.countryCode)
  //   }
  // }

  // @Watch('genreId')
  // @Watch('countryCode')
  // async fetchMusicChartsTracks() {
  //   if (!this.genreId || !this.countryCode) return

  //   this.loading = true

  //   await this.$store.dispatch('musiccharts/fetchCountryGenreTracks', {
  //     genreId: this.genreId,
  //     countryCode: this.countryCode
  //   })

  //   this.initialized = true
  //   this.view = VIEWS.TrackList

  //   this.loading = false
  // }
}
